import React from 'react';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline'

// components

// svgs
import phoneDarkSVG from '../../../inlineSVGs/phoneDarkSVG';
import ticketsSVG from '../../../inlineSVGs/ticketsSVG';
import pinOnMapDarkSVG from '../../../inlineSVGs/pinOnMapDarkSVG';
import shareDarkSVG from '../../../inlineSVGs/shareDarkSVG';

// styles
import './RoundTypeButton.css';

const RoundTypeButton = ({ handleClick, customClass, type = '', buttonType }) => {

    let iconSVG = '';
    switch (buttonType) {
        case 'phone':
            iconSVG = phoneDarkSVG;
            break;
        case 'tickets':
            iconSVG = ticketsSVG;
            break;
        case 'location':
            iconSVG = pinOnMapDarkSVG;
            break;
        case 'share':
            iconSVG = shareDarkSVG;
            break;
        default:
    }

    return (
        <div className={`round-type-button-wrapper ${type} ${customClass}`} onClick={handleClick}>
            <SVGInline className="location-icon" width="30px" svg={iconSVG} component="i"/>
        </div>
    )
};

RoundTypeButton.propTypes = {
    handleClick: PropTypes.func,
    customClass: PropTypes.string,
    type: PropTypes.string,
    buttonType: PropTypes.string
};

export default RoundTypeButton;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/ModalElements/RoundTypeButton/RoundTypeButton.js